// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ilo-header-apps-dropdown {
  background-color: #fff;
  border: 1px solid var(--border-action-normal, #dee0e3);
  border-radius: 12px;
  box-shadow: 0 10px 25px -3px rgba(20, 21, 26, 0.12);
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 0;
  top: 42px;
  width: max-content !important;
  z-index: 1000;
  gap: 10px;
  padding: 14px;
}
.ilo-header-apps-dropdown-icon {
  align-items: center;
  border-radius: 10px;
  color: rgba(15, 19, 36, 0.6);
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: 400;
  gap: 8px;
  padding: 8px 12px;
  transition: background-color 0.15s ease;
}
.ilo-header-apps-dropdown-icon:hover {
  background-color: #f0f5ff;
  color: #4778f5;
}
.ilo-header-apps-dropdown-row-one, .ilo-header-apps-dropdown-row-two, .ilo-header-apps-dropdown-row-three {
  display: flex;
  justify-content: space-between;
}
.ilo-header-apps-dropdown-row-one a, .ilo-header-apps-dropdown-row-two a, .ilo-header-apps-dropdown-row-three a {
  text-decoration: none;
}
.ilo-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 3px 6px -2px rgba(20, 21, 26, 0.0509803922);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #0B406E;
  z-index: 99999;
  padding: 15px;
}
.ilo-header-avtar-dropdown {
  background-color: #fff;
  border: 1px solid var(--border-action-normal, #dee0e3);
  border-radius: 12px;
  box-shadow: 0 10px 25px -3px rgba(20, 21, 26, 0.12);
  display: flex;
  flex-direction: column;
  min-width: 220px;
  position: absolute;
  right: 0;
  top: 42px;
  width: max-content !important;
  z-index: 1000;
}
.ilo-header-avtar-dropdown-top {
  align-items: center;
  align-items: flex-start;
  display: flex;
  gap: 10px;
  padding: 10px;
}
.ilo-header-avtar-dropdown-top-right {
  display: flex;
  flex-direction: column;
}
.ilo-header-avtar-dropdown-top-right-name {
  color: #14151a;
  font-size: 14px;
  font-weight: 500;
}
.ilo-header-avtar-dropdown-top-right-email {
  color: rgba(15, 19, 36, 0.6);
  font-size: 12px;
  font-weight: 400;
}
.ilo-header-avtar-dropdown-middle {
  border-bottom: 1px solid #e9eaec;
  border-top: 1px solid #e9eaec;
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: 10px 0;
  padding: 5px 0;
}
.ilo-header-avtar-dropdown-middle-item {
  border-radius: 10px;
  color: #14151a;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  gap: 10px;
  margin: 0 8px;
  padding: 5px;
  cursor: pointer;
}
.ilo-header-avtar-dropdown-bottom {
  display: flex;
  justify-content: center;
  padding: 0 5px 10px;
}
.ilo-header-avtar-dropdown-bottom-item {
  background-color: #fff;
  border: 1px solid #dee0e3;
  border: 1px solid var(--border-action-normal, #dee0e3);
  border-radius: 10px;
  color: #14151a;
  font-size: 14px;
  font-weight: 500;
  padding: 7px 16px;
  text-align: center;
  white-space: nowrap;
  width: 90%;
  cursor: pointer;
}
.ilo-header-center {
  display: flex;
  gap: 20px;
}
.ilo-header-center a {
  font-size: 16px;
  color: #FFFFFF;
  text-decoration: none;
  font-weight: 500;
}
.ilo-header-left {
  font-size: 32px;
  font-weight: 800;
  color: #FFFFFF;
  position: relative;
  display: inline-flex;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
}
.ilo-header-left img {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), filter 0.3s ease;
}
.ilo-header-left span {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.ilo-header-left::after {
  content: "";
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0%;
  height: 3px;
  background: linear-gradient(90deg, #22D3EE 0%, #38BDF8 50%, #67E8F9 100%);
  border-radius: 2px;
  transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 0 10px rgba(56, 189, 248, 0.55);
}
.ilo-header-left:hover {
  transform: translateY(-1px) scale(1.015);
  filter: drop-shadow(0 4px 12px rgba(245, 158, 11, 0.4));
}
.ilo-header-left:hover span {
  background: linear-gradient(135deg, #FFFFFF 10%, #FDE047 60%, #F59E0B 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.ilo-header-left:hover img {
  transform: rotate(-6deg) scale(1.08);
}
.ilo-header-left:hover::after {
  width: 100%;
}
.ilo-header-right {
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  display: flex;
  gap: 20px;
  align-items: center;
}
.ilo-header-right-avatar {
  background-color: #f59e0b;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  height: 30px;
  justify-content: center;
  width: 30px;
  align-items: center;
}
.ilo-header-right-button-signup {
  background-color: white;
  border: 1px solid var(--border-action-normal, #DEE0E3);
  box-shadow: 0px 1px 2px 0px rgba(20, 21, 26, 0.0509803922);
  color: #14151A;
  padding: 8px 10px;
  border-radius: 15px;
  width: 95px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
}
.ilo-header-right-button-login {
  background-color: #062C3B;
  box-shadow: 0px 1px 2px 0px rgba(20, 21, 26, 0.0509803922);
  padding: 10px 10px;
  border-radius: 15px;
  font-size: 16px;
  width: 80px;
  text-align: center;
  cursor: pointer;
}

@media (max-width: 600px) {
  .ilo-header-left {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.scss"],"names":[],"mappings":"AAEI;EACI,sBAAA;EACA,sDAAA;EACA,mBAAA;EACA,mDAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;AADR;AAGQ;EACI,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,iBAAA;EACA,uCAAA;AADZ;AAGY;EACI,yBAAA;EACA,cAAA;AADhB;AAKQ;EAGI,aAAA;EACA,8BAAA;AALZ;AAOY;EACI,qBAAA;AALhB;AArCA;EAgDI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,2DAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;AARJ;AAUI;EACI,sBAAA;EACA,sDAAA;EACA,mBAAA;EACA,mDAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;EACA,aAAA;AARR;AAUQ;EACI,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;AARZ;AAUY;EACI,aAAA;EACA,sBAAA;AARhB;AAUgB;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AARpB;AAWgB;EACI,4BAAA;EACA,eAAA;EACA,gBAAA;AATpB;AAcQ;EACI,gCAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,cAAA;AAZZ;AAcY;EACI,mBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AAZhB;AAgBQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAdZ;AAgBY;EACI,sBAAA;EACA,yBAAA;EACA,sDAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;AAdhB;AAmBI;EACI,aAAA;EACA,SAAA;AAjBR;AAmBQ;EACI,eAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;AAjBZ;AAqBI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iDAAA;EACA,qBAAA;AAnBR;AAqBQ;EACI,yEAAA;AAnBZ;AAsBQ;EACI,iDAAA;AApBZ;AAuBQ;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EAEA,yEAAA;EAKA,kBAAA;EAEA,oDAAA;EAEA,6CAAA;AA5BZ;AA+BQ;EACI,wCAAA;EACA,uDAAA;AA7BZ;AA+BY;EACI,2EAAA;EACA,6BAAA;EACA,oCAAA;AA7BhB;AAgCY;EACI,oCAAA;AA9BhB;AAiCY;EACI,WAAA;AA/BhB;AAoCI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAlCR;AAoCQ;EACI,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;AAlCZ;AAsCY;EACI,uBAAA;EACA,sDAAA;EACA,0DAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AApChB;AAwCY;EACI,yBAAA;EACA,0DAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAtChB;;AA4CA;EACI;IACI,eAAA;EAzCN;AACF","sourcesContent":[".ilo-header {\n\n    &-apps-dropdown {\n        background-color: #fff;\n        border: 1px solid var(--border-action-normal, #dee0e3);\n        border-radius: 12px;\n        box-shadow: 0 10px 25px -3px rgba(20, 21, 26, 0.12);\n        display: flex;\n        flex-direction: column;\n        position: absolute;\n        right: 0;\n        top: 42px;\n        width: max-content !important;\n        z-index: 1000;\n        gap: 10px;\n        padding: 14px;\n\n        &-icon {\n            align-items: center;\n            border-radius: 10px;\n            color: #0f132499;\n            display: flex;\n            flex-direction: column;\n            font-size: 12px;\n            font-weight: 400;\n            gap: 8px;\n            padding: 8px 12px;\n            transition: background-color 0.15s ease;\n\n            &:hover {\n                background-color: #f0f5ff;\n                color: #4778f5;\n            }\n        }\n\n        &-row-one,\n        &-row-two,\n        &-row-three {\n            display: flex;\n            justify-content: space-between;\n\n            a {\n                text-decoration: none;\n            }\n\n        }\n    }\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 0px 3px 6px -2px #14151A0D;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #0B406E;\n    z-index: 99999;\n    padding: 15px;\n\n    &-avtar-dropdown {\n        background-color: #fff;\n        border: 1px solid var(--border-action-normal, #dee0e3);\n        border-radius: 12px;\n        box-shadow: 0 10px 25px -3px rgba(20, 21, 26, 0.12);\n        display: flex;\n        flex-direction: column;\n        min-width: 220px;\n        position: absolute;\n        right: 0;\n        top: 42px;\n        width: max-content !important;\n        z-index: 1000;\n\n        &-top {\n            align-items: center;\n            align-items: flex-start;\n            display: flex;\n            gap: 10px;\n            padding: 10px;\n\n            &-right {\n                display: flex;\n                flex-direction: column;\n\n                &-name {\n                    color: #14151a;\n                    font-size: 14px;\n                    font-weight: 500;\n                }\n\n                &-email {\n                    color: #0f132499;\n                    font-size: 12px;\n                    font-weight: 400;\n                }\n            }\n        }\n\n        &-middle {\n            border-bottom: 1px solid #e9eaec;\n            border-top: 1px solid #e9eaec;\n            display: flex;\n            flex-direction: column;\n            gap: 5px;\n            margin: 10px 0;\n            padding: 5px 0;\n\n            &-item {\n                border-radius: 10px;\n                color: #14151a;\n                display: flex;\n                font-size: 14px;\n                font-weight: 500;\n                gap: 10px;\n                margin: 0 8px;\n                padding: 5px;\n                cursor: pointer;\n            }\n        }\n\n        &-bottom {\n            display: flex;\n            justify-content: center;\n            padding: 0 5px 10px;\n\n            &-item {\n                background-color: #fff;\n                border: 1px solid #dee0e3;\n                border: 1px solid var(--border-action-normal, #dee0e3);\n                border-radius: 10px;\n                color: #14151a;\n                font-size: 14px;\n                font-weight: 500;\n                padding: 7px 16px;\n                text-align: center;\n                white-space: nowrap;\n                width: 90%;\n                cursor: pointer;\n            }\n        }\n    }\n\n    &-center {\n        display: flex;\n        gap: 20px;\n\n        a {\n            font-size: 16px;\n            color: #FFFFFF;\n            text-decoration: none;\n            font-weight: 500;\n        }\n    }\n\n    &-left {\n        font-size: 32px;\n        font-weight: 800;\n        color: #FFFFFF;\n        position: relative;\n        display: inline-flex;\n        align-items: center;\n        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n        text-decoration: none;\n\n        img {\n            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), filter 0.3s ease;\n        }\n\n        span {\n            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n        }\n\n        &::after {\n            content: \"\";\n            position: absolute;\n            bottom: -4px;\n            left: 0;\n            width: 0%;\n            height: 3px;\n\n            background: linear-gradient(90deg,\n                    #22D3EE 0%,\n                    #38BDF8 50%,\n                    #67E8F9 100%);\n\n            border-radius: 2px;\n\n            transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n\n            box-shadow: 0 0 10px rgba(56, 189, 248, 0.55);\n        }\n\n        &:hover {\n            transform: translateY(-1px) scale(1.015);\n            filter: drop-shadow(0 4px 12px rgba(245, 158, 11, 0.4));\n\n            span {\n                background: linear-gradient(135deg, #FFFFFF 10%, #FDE047 60%, #F59E0B 100%);\n                -webkit-background-clip: text;\n                -webkit-text-fill-color: transparent;\n            }\n\n            img {\n                transform: rotate(-6deg) scale(1.08);\n            }\n\n            &::after {\n                width: 100%;\n            }\n        }\n    }\n\n    &-right {\n        font-size: 16px;\n        font-weight: 500;\n        color: #FFFFFF;\n        display: flex;\n        gap: 20px;\n        align-items: center;\n\n        &-avatar {\n            background-color: #f59e0b;\n            border-radius: 50%;\n            color: #fff;\n            cursor: pointer;\n            display: flex;\n            font-size: 14px;\n            font-weight: 500;\n            height: 30px;\n            justify-content: center;\n            width: 30px;\n            align-items: center;\n        }\n\n        &-button {\n            &-signup {\n                background-color: white;\n                border: 1px solid var(--border-action-normal, #DEE0E3);\n                box-shadow: 0px 1px 2px 0px #14151A0D;\n                color: #14151A;\n                padding: 8px 10px;\n                border-radius: 15px;\n                width: 95px;\n                font-size: 16px;\n                cursor: pointer;\n                text-align: center;\n\n            }\n\n            &-login {\n                background-color: #062C3B;\n                box-shadow: 0px 1px 2px 0px #14151A0D;\n                padding: 10px 10px;\n                border-radius: 15px;\n                font-size: 16px;\n                width: 80px;\n                text-align: center;\n                cursor: pointer;\n            }\n        }\n    }\n}\n\n@media (max-width: 600px) {\n    .ilo-header-left {\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
